import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Button, HStack, IconButton, useBreakpointValue } from '@chakra-ui/react';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { AppLayoutToolbar } from '@src/components/sco/AppLayout/Toolbar/AppLayoutToolbar.tsx';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { ArrowBackIcon, ArrowForwardIcon } from '@src/components/sco/icons';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { Video } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import { useSearchParams } from 'next/navigation';
import React, { useEffect, useState } from 'react';
type VideoToolbarProps = {
  videoListSlug?: string;
  videoSlug?: string;
  isNavPanelOpen?: string;
  isAsidePanelOpen?: string;
};
export const VideoToolbar = props => {
  const $ = _c(23);
  const layout = useParentAppLayout();
  const educationContext = useEducationContext();
  useBreakpointContext();
  let t0;
  if ($[0] !== layout) {
    t0 = layout.getPanel("edu-aside")?.useDrawerBreakpoints || {
      base: false
    };
    $[0] = layout;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useBreakpointValue(t0);
  let t1;
  if ($[2] !== layout) {
    t1 = layout.getPanel("edu-nav")?.useDrawerBreakpoints || {
      base: false
    };
    $[2] = layout;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useBreakpointValue(t1);
  educationContext.activeContent.item?.id;
  useSearchParams();
  const [activeVideo, setActiveVideo] = useState();
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = VideoToolbar.queries.videoList();
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.videoListSlug) {
    t3 = {
      variables: {
        videoListSlug: props.videoListSlug
      }
    };
    $[5] = props.videoListSlug;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const videoListQuery = useQuery(t2, t3);
  const videoList = videoListQuery.data?.videoList;
  let t4;
  if ($[7] !== props.videoSlug || $[8] !== videoList) {
    t4 = () => {
      if (videoList) {
        setActiveVideo(videoList.videos.find(video => video.slug === props.videoSlug));
      }
    };
    $[7] = props.videoSlug;
    $[8] = videoList;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = videoList?.id;
  let t6;
  if ($[10] !== props.videoSlug || $[11] !== t5) {
    t6 = [t5, props.videoSlug];
    $[10] = props.videoSlug;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useEffect(t4, t6);
  if (!videoList) {
    let t7;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <></>;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    return t7;
  }
  const activeVideoIndex = videoList.videos?.findIndex(video_0 => video_0.id == activeVideo?.id) || 0;
  const nextVideo = videoList.videos[activeVideoIndex + 1];
  const prevVideo = videoList.videos[activeVideoIndex - 1];
  let t7;
  if ($[14] !== prevVideo || $[15] !== videoList.slug) {
    t7 = prevVideo ? <NextLink href={`/videos/${videoList.slug}/${prevVideo.slug}`} passHref={true}><IconButton aria-label="Previous" as="span" borderColor="actionPrimaryAlpha.200" size="sm" variant="outline"><ArrowBackIcon /></IconButton></NextLink> : <div />;
    $[14] = prevVideo;
    $[15] = videoList.slug;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== nextVideo || $[18] !== videoList.slug) {
    t8 = nextVideo && <Button asChild={true} size="sm" variant="outline"><NextLink href={`/videos/${videoList.slug}/${nextVideo.slug}?play=1`}>Next Video<ArrowForwardIcon /></NextLink></Button>;
    $[17] = nextVideo;
    $[18] = videoList.slug;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8) {
    t9 = <AppLayoutToolbar rightElements={<><HStack gap={4}><HStack justify="space-between">{t7}{t8}</HStack></HStack></>} />;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
VideoToolbar.queries = {
  videoList: () => gql`
    query ($videoListSlug: String) {
      videoList(where: { slug: $videoListSlug }) {
        id
        featuredImage {
          id
          url(transformation: { image: { resize: { fit: max, width: 1000 } } })
        }
        slug
        title
        shortDescription
        people {
          id
          firstName
          lastName
          email
        }
        videos {
          id
          slug
          title
          featuredImage {
            id
            url
          }
          title
          subtitle
          transcript
          people {
            id
            firstName
            lastName
            shortBio
            avatar {
              url
            }
          }
          longDescription
          videoUrl
        }
      }
    }
  `
};